
const formulas = () => {
    const oneAtm = (isMetric: boolean) => isMetric ? 10 : 33

    const calcMod = (mix: number, ppO2: number, useMetric: boolean = true): number => {
        const mixInPercent = mix / 100;
        return ((ppO2 / mixInPercent) - 1) * oneAtm(useMetric);
    }

    const calcEnd = (helium: number, depth: number, useMetric: boolean = true): number => {
        const heInFraction = helium / 100;
        return (((1 - heInFraction) * depth + oneAtm(useMetric)) - oneAtm(useMetric));
    }

    const calcEad = (ean: number, depth: number, useMetric: boolean = true) : number => {
        const mixInPercent = Number(ean) / 100;
        return Math.ceil((((1 - mixInPercent) * (oneAtm(useMetric) + depth)) / 0.79) - oneAtm(useMetric));
    }

    const calcBestMixNitrox = (ppO2: number, depth: number, useMetric: boolean = true): number => {
        return ((ppO2 / ((depth / oneAtm(useMetric) ) + 1)) *100);
    }

    const calcBestMixTrimix = (ppO2: number, narcoticDepth: number, depth: number, useMetric: boolean = true) => {
        const depthInBar = ((depth / oneAtm(useMetric) ) + 1);
        const narcoticDepthInBar = ((narcoticDepth / oneAtm(useMetric)) + 1 );
        const cfo2 = Math.floor((ppO2 / ((depth / oneAtm(useMetric) ) + 1)) *100);
        const cfhe = Math.ceil(((depthInBar - narcoticDepthInBar) / depthInBar) * 100);
        return {fhe: cfhe, fO2: cfo2};
    }

    const calcHeliair = (end: number, depth: number, targetPressure: number, useMetric: boolean = true) => {
        const cfhe = 1.0 - ((end + oneAtm(useMetric)) / (depth + oneAtm(useMetric)));
        const cfO2 = ((end + oneAtm(useMetric)) / (depth + oneAtm(useMetric))) * .21;
        const cppO2 = cfO2 * ((depth + oneAtm(useMetric)) / oneAtm(useMetric));

        return {
            fHe: cfhe,
            fO2: cfO2,
            ppO2: cppO2,
            pO2: Math.round(targetPressure * cfO2),
            pHe: Math.round(targetPressure * cfhe)
        }
    }

    return {
        calcHeliair,
        calcBestMixNitrox,
        calcBestMixTrimix,
        calcMod,
        calcEad,
        calcEnd
    }
}

export default formulas;